export default __webpack_public_path__ + "locales/hy-AM/SMTPSettings.json?hash=80f0ee7534edecab9b858762ae9ffb86";